import { identifyMedia } from 'utils'
import { MediaFrame } from '../../../types'
import { getGifFrames } from './gif'
import { getImageFrames } from './image'
import { getVideoFrames } from './video'

const FRAME_CACHE: { [key: string]: MediaFrame[] } = {}

export function drawToCanvas(source: CanvasImageSource, width: number, height: number) {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    canvas.width = width
    canvas.height = height
    context?.drawImage(source, 0, 0, width, height)

    return canvas
}

async function getFrames(source: File | string, maxFrames?: number): Promise<MediaFrame[]> {
    const mediaType = identifyMedia(source)

    switch (mediaType) {
        case 'gif':
            return getGifFrames(source, maxFrames)
        case 'image':
            return getImageFrames(source)
        case 'video':
            return getVideoFrames(source, 24, maxFrames)
        default:
            return []
    }
}

export async function mediaFramesFromSource(
    source: File | string,
    maxFrames?: number,
    ignoreCache?: boolean
): Promise<MediaFrame[]> {
    const id = typeof source === 'string' ? source : source.name
    const cacheId = maxFrames ? `${id}-${maxFrames}` : id

    if (!ignoreCache && FRAME_CACHE[cacheId]) {
        return FRAME_CACHE[cacheId]
    }

    const frames = await getFrames(source, maxFrames)

    if (!ignoreCache && frames.length) {
        FRAME_CACHE[cacheId] = frames
    }

    return frames
}
